<script>

	export default {
        computed: {
		    cart() {
		        return this.$store.state.cart
            },
            code: {
                get () {
                    return this.$store.state.coupon.code
                },
                set (value) {
                    this.$store.commit("coupon", {
                        code: value,
                        message: null,
                        error: false,
                        loading: false,
                    })
                }
            },
            message() {
                return this.$store.state.coupon.message
            },
            error() {
                return this.$store.state.coupon.error
            },
            loading() {
                return this.$store.state.coupon.loading
            },
            discountString() {
                return this.$store.state.coupon.discountString
            }
        },
		methods: {
			getCoupon() {
                let code = this.$store.state.coupon.code

                if (!this.validateCoupon(code)) {
                    return
                }

				this.$store.commit("coupon", {
				    loading: true,
				    error: false
				})

				this.$http.get(`${ab.apiUrl}/coupons`, {params: {user_id: this.$store.state.user.id, coupon_code: code}})
                    .then((response) => {

                        let coupon = response.data.item;

                        this.cart.setCoupon(coupon);
                        
                        let message = `A ${coupon.discount}% discount has been applied to `; 
                        message += coupon.applies_to.map(type => (type+"s").toUpperCase()).join(", ");
                        
                        if(coupon.licenses.length){
                            message += " and the following licenses: ";
                            let licenseNames = []
                            for (let i in coupon.licenses) {
                                let license = coupon.licenses[i];
                                licenseNames.push(license.name);
                            }
                            message += licenseNames.join(", ");
                        }

                        if (coupon.maxItems) {
                            message += ". MAX " + coupon.maxItems + `${coupon.maxItems > 1 ? " ITEMS" : " ITEM"}.`
                        }
                        
                        this.$store.commit("coupon", {
                            loading: false,
                            error: false,
                            discountString: message
                        })

						this.$store.state.eventTracker.applyCoupon(coupon);
                    })
                    .catch((error) => {
                        let message = `${error.response.data.error.message}`
                        this.$store.commit("coupon", {
                            loading: false,
                            error: true,
                            message: message
                        })
                    });
			},
            resetError() {
                if (this.$store.state.coupon.error) {
                    this.$store.commit("coupon", {
                        error: false,
                        message: false
                    })
                }
            },
            validateCoupon(code) {
                if (code === "") {
                    this.$store.commit("coupon", {
                        error: true,
                        message: "Please enter a coupon code",
                        loading: false
                    })
                    return false
                }

                return true
            }
		}
	}
</script>
